// extracted by mini-css-extract-plugin
export var menuIcon = "_r0-0";
export var menuIconInline = "_r0-1";